import React from "react";
import { useTable, useSortBy } from "react-table";
import images from "../../assets/images/constantImages";
import icons from "../../assets/images/constantIcons";

const Table = ({ columns, data, highlightedRow }) => {
  const alphanumericSort = (rowA, rowB, columnId) => {
    const valA = rowA.values[columnId]?.toString().trim().toLowerCase() || "";
    const valB = rowB.values[columnId]?.toString().trim().toLowerCase() || "";

    return valA.localeCompare(valB, undefined, {
      numeric: true,
      sensitivity: "base",
    });
  };

  // Apply it globally
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
        sortTypes: {
          alphanumeric: alphanumericSort, // Use the improved sorting
        },
        defaultColumn: {
          sortType: "alphanumeric",
        },
      },
      useSortBy
    );

  return (
    <div className="dashboard-table">
      <table
        {...getTableProps()}
        className="commontable w-full table-auto border-separate hidden sm:table"
        style={{ borderSpacing: "0 10px" }}
      >
        {/* Table Headers */}
        <thead className="">
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps(
                    column.disableSortBy ? {} : column.getSortByToggleProps()
                  )}
                  className="px-2 py-2 uppercase bg-gray-50 text-green text-sm  text-nowrap h-[60px] text-center cursor-pointer "
                  key={column.id}
                >
                  <div className="flex items-center justify-center gap-1">
                    {column.render("Header")}
                    {!column.disableSortBy && (
                      <span>
                        {column.isSorted ? (
                          column.isSortedDesc ? (
                            <icons.TiArrowDown className="inline-block text-green700" />
                          ) : (
                            <icons.TiArrowUp className="inline-block text-green700" />
                          )
                        ) : (
                          <icons.HiMiniArrowsUpDown className="inline-block  text-green700" />
                        )}
                      </span>
                    )}
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>

        {/* Table Body */}
        <tbody {...getTableBodyProps()}>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="text-center py-10">
                <div className="no-data w-full flex justify-center">
                  <img
                    src={images.nodataimg}
                    alt="No data available"
                    className="w-[160px] h-[160px]"
                  />
                </div>
              </td>
            </tr>
          ) : (
            rows.map((row) => {
              prepareRow(row);
              return (
                <tr
                  {...row.getRowProps()}
                  className={`h-[50px] ${highlightedRow?.value == row.original.id &&
                      row.original.id != undefined
                      ? "bg-[#e5e0388c]"
                      : "bg-white"
                    }`}
                  key={row.id}
                >
                  {row.cells.map((cell) => (
                    <td
                      {...cell.getCellProps()}
                      className="pl-2 pr-2 py-1 text-sm text-G500 text-center"
                      key={cell.column.id}
                    >
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })
          )}
        </tbody>
      </table>

      {/* Responsive Cards */}
      <div className="sm:hidden ">
        {rows.length === 0 ? (
          <div className="text-center py-10">
            <div className="no-data w-full flex justify-center">
              <img
                src={images.nodataimg}
                alt="No data available"
                className="w-[160px] h-[160px]"
              />
            </div>
          </div>
        ) : (
          rows.map((row) => {
            prepareRow(row);
            return (
              <div
                {...row.getRowProps()}
                className="bg-white mb-5 p-4 rounded-lg shadow-lg overflow-x-auto"
                key={row.id}
              >
                {row.cells.map((cell) => (
                  <div
                    key={cell.column.id}
                    className="flex items-center text-sm text-G500 py-1 w-full"
                  >
                    <span className="font-semibold w-1/2 text-xs xs:text-sm uppercase">
                      {cell.column.render("Header")}
                    </span>

                    <span className="w-1/2 text-xs xs:text-sm">
                      {cell.render("Cell")}
                    </span>
                  </div>
                ))}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default Table;
